export const PACKAGE_NUMBER_FORMAT_VU = '0000000000';
